import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { v4 as uuid } from 'uuid';
import { CriteriaGroup, CriteriasGroups } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class CompanyRankingService {

  constructor(
    private readonly apollo: Apollo
  ) { }

  async getCriteriasGroups(): Promise<CriteriasGroups[]> {
    return await this.apollo
      .query<any>({
        query: gql`
          query criteriasGroups($where: CriteriasGroupsWhereInput, $orderBy: CriteriasGroupsOrderByInput, $limit: Int, $offset: Int) {
            criteriasGroups(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
              totalCount
              items {
                id
                name
              }
            }
          }
        `,
        variables: {
          orderBy: 'name_asc'
        }
      })
      .toPromise()
      .then((result) => result.data.criteriasGroups.items);
  }

  async getCriteriasGroupById(id: string): Promise<CriteriaGroup> {
    return await this.apollo
      .query<any>({
        query: gql`
          query criteriaGroup($id: ID!) {
            criteriaGroup(id: $id) {
              id
              name
              createdAt
              updatedAt
              criterias {
                id
                value {
                  ... on CriteriaValuePoints {
                    points
                    maintenanceTypeIds
                  }
                  ... on CriteriaValueResultThreshold {
                    points
                    resultThreshold
                    maintenanceTypeIds
                  }
                  ... on CriteriaValuePercentRange {
                    percentRange {
                      start
                      end
                      points
                      discount
                    }
                    maintenanceTypeIds
                  }
                }
                ruleName
              }
            }
          }
        `,
        variables: {
          id: id
        }
      })
      .toPromise()
      .then((result) => result.data.criteriaGroup);
  }

  async criteriasDataByCriteriasGroupId(id: string, where): Promise<any> {
    return await this.apollo
      .query<any>({
        query: gql`
          query criteriasDataByCriteriasGroupId($id: ID!, $where: CriteriasGroupsDataWhereInput) {
            criteriasDataByCriteriasGroupId(id: $id, where: $where) {
              company {
                id
                name
                avatarUrl
              }
              criteriasResult {
                id
                ruleName
                value
              }
            }
          }
        `,
        variables: {
          id: id,
          where
        }
      })
      .toPromise()
      .then((result) => result.data.criteriasDataByCriteriasGroupId);
  }

  async deleteCriteriasGroupById(id: string): Promise<void> {
    return await this.apollo
      .query<any>({
        query: gql`
        mutation deleteCriteriasGroup($id: ID!) {
        deleteCriteriasGroup(id: $id) {
          id
        }
      }
      `,
        variables: {
          id: id
        }
      })
      .toPromise()
      .then((result) => result.data.deleteCriteriasGroup);
  }

  async updateCriteriasGroup(id: string, input: any): Promise<void> {
    return await this.apollo
      .query<any>({
        query: gql`
          mutation updateCriteriasGroup($id: ID!, $input: CriteriaGroupInput!) {
          updateCriteriasGroup(id: $id, input: $input) {
            id
            name
            updatedBy {
              id
              name
            }
            updatedAt
            createdBy {
              id
              name
            }
            createdAt
            criterias {
              id
              ruleName
              value {
                ... on CriteriaValuePoints {
                  points
                }
                ... on CriteriaValueResultThreshold {
                  points
                  resultThreshold
                }
              }
            }
          }
        }
      `,
        variables: {
          id: id,
          input: {
            id: uuid(),
            ...input
          }
        }
      })
      .toPromise()
      .then((result) => result.data.deleteCriteriasGroup);
  }

  async addCriteriasGroup(input: any): Promise<void> {
    return await this.apollo
      .query<any>({
        query: gql`
          mutation createCriteriasGroup($input: CriteriaGroupInput!) {
            createCriteriasGroup(input: $input) {
              id
              name
              updatedBy {
                id
                name
              }
              updatedAt
              createdBy {
                id
                name
              }
              createdAt
              criterias {
                id
                ruleName
                value {
                  ... on CriteriaValuePoints {
                    points
                  }
                  ... on CriteriaValueResultThreshold {
                    points
                    resultThreshold
                  }
                }
              }
            }
        }
      `,
        variables: {
          input: {
            id: uuid(),
            ...input
          }
        }
      })
      .toPromise()
      .then((result) => result.data.deleteCriteriasGroup);
  }
}
